<template>
    <v-content>
      <v-container fluid>
        <v-col cols="12">
          <v-card raised>
            <v-row v-if="errors.length">
              <v-col cols="12" sm="12" md="12">
                <v-alert
                  dense
                  outlined
                  type="error"
                  >{{ errors }}</v-alert
                >
              </v-col>
            </v-row>
            <v-card color="#385F73" height="315" dark>
              <v-container>
                <v-row>
                  <v-col cols="12" v-bind:md="this.$store.state.globals.mini ? 8 : 7">
                    <v-card-title class="headline">{{ individualcourse.course_name }}</v-card-title>
                    <v-card-subtitle class="pt-5" v-html='individualcourse.description'></v-card-subtitle>
                    <div class="my-4 text-subtitle-1">
                      <p v-if="(individualcourse.authors).length">
                      <v-icon color="#fff" class="ml-2">{{((individualcourse.authors).length>1)? 'mdi-account-multiple' : ' mdi-account'}}</v-icon> 
                      <span v-for="(authors,index) in individualcourse.authors" :key='index'> 
                        <span v-if="index>0"> ,  </span>{{ authors.author_name }} 
                      </span>
                      </p>
                      <p v-if="individualcourse.created_at">
                        <v-icon color="#fff" class="ml-2">mdi-calendar</v-icon>{{"Created On:" | translate}} {{ getDate(individualcourse.created_at)}}
                      </p>
                      <p  v-if="individualcourse.course_ends_on">
                        <v-icon color="#fff" class="ml-2">mdi-calendar</v-icon>{{"Course Subscription Ends On:" | translate}} {{ getDate(individualcourse.course_ends_on)}}
                      </p>
                      <p>
                        <v-icon color="#fff" class="ml-2" v-if="individualcourse.language">mdi-web </v-icon> {{ (individualcourse.language? individualcourse.language.lang_name : '') | translate }}
                      </p>
                    </div>  
                                    
  
                  </v-col>
                  <v-col
                    cols="12"
                    v-bind:md="this.$store.state.globals.mini ? 4 : 5 "
                    style="position: relative"
                  >
                    <div id="floatingbox" class="floatingbox">
                      <v-card color="white" class="mx-auto buycard">
                        <v-img
                          class="white--text align-end buyimage"
                          height="200px"
                          :src="storage_url+individualcourse.course_image "
                        ></v-img>
                        <v-card-text class="text--primary">
                          <div class="pt-1 pb-1">
                            <h2 class="text-center">{{ individualcourse.title }}</h2>
                          </div>
                          <div
                            class="pt-1 pb-1"
                            v-if="(Object.keys(currentUser).length !=0 && currentUser.company.account_type == 'on-demand' )"
                          >
                          </div>
  
                          <div
                            class="pt-1 pb-1"
                            v-if="(Object.keys(currentUser).length !=0 && currentUser.company.account_type == 'on-demand' && is_subscribed )"
                          >
                            <h3 class="text-center">{{ 'Purchased'| translate }}</h3>
                          </div>
  
                          <div
                            class="pt-1 pb-1"
                            v-if="(Object.keys(currentUser).length !=0 && currentUser.company.account_type == 'full-version' )"
                          >
                            <h3 class="text-center">{{ 'Included'| translate }}</h3>
                          </div>

                          <div class="my-2" v-if="(!individualcourse.is_subscribed) || (!currentUser.roles.includes(5) && draftStatus)">
                            <v-btn
                              large
                              block
                              color="error"
                              @click="checkCard(individualcourse)"
                              dark
                            >{{ 'Subscribe'| translate }}</v-btn>
                          </div>
                          <div class="my-2" v-if="(individualcourse.is_subscribed) || (currentUser.roles.includes(5) && draftStatus)">
                            <v-btn
                              large
                              block
                              color="success"
                              @click="modulePlayer(individualcourse.course_id,individualcourse.in_progress_module)"
                              dark
                            >{{ 'PLAY NOW'| translate }}</v-btn>
                          </div>
                        </v-card-text>
                      </v-card>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
            <v-container>
              <v-row>
                <v-col cols="12" v-bind:md="$store.state.globals.mini ? 8 : 7 ">
                  <v-row>
                    <v-col cols="12" md="12">
                      <div class="pt-4 pb-4 learn">
                        <h3>{{ 'What Will you Learn?'| translate }}</h3>
                        <div class="pt-5">
                          <p v-html="individualcourse.learn"></p>
                        </div>
                      </div>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="12">
                            <template>
                                <v-card
                                    class="overflow-auto"
                                    min-height="120"
                                >
                                    <v-toolbar
                                    color="#385F73"
                                    dark
                                    style="position: sticky;top: 0"
                                    >
                                    <v-toolbar-title>{{ "Course Modules" | translate}}</v-toolbar-title>
                                    </v-toolbar>
                                    
                                        <v-list>
                                            <v-list-group
                                            v-for="(mod, index) in individualcourse.company_modules"
                                            :key="index"
                                            no-action
                                            >
                                            <template v-slot:activator>
                                              <v-btn
                                                  class="book-button"
                                                  rounded
                                                  fab 
                                                  icon
                                                  v-if="mod.show_module && individualcourse.is_subscribed"
                                                  @click="modulePlayer(mod.course_id,mod.module_id)"
                                                >
                                                  <v-icon>mdi-play-circle </v-icon>
                                                </v-btn>
                                                <v-btn
                                                  class="book-button"
                                                  rounded
                                                  fab 
                                                  icon
                                                  @click="lockMessage=true"
                                                  lockMessage
                                                  v-else
                                                >
                                                  <v-icon>mdi-lock </v-icon>
                                                </v-btn>
                                                <v-list-item-content>
                                                <v-list-item-title v-text="mod.title"></v-list-item-title>
                                                </v-list-item-content>
                                            </template>

                                            <v-card elevation="5" class="pa-2 pb-6 mb-2"> 
                                                <p v-html="mod.description"></p>
                                            </v-card>

                                            </v-list-group>
                                        </v-list>

                                </v-card>

                                </template>
                            </v-col>
                  </v-row>
  
                  <v-row>
                    <v-col cols="12" md="12">
                      <div class="pt-4 pb-4">
                        <h3>{{ 'Requirements'| translate }}</h3>
                        <div class="pt-5">
                          <p v-html="individualcourse.requirement"></p>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
  
                  <v-divider></v-divider>

                  <v-row>
                    <v-col cols="12" md="12">
                      <div class="pt-4 pb-4">
                        <h3>{{ 'Glossary'| translate }}</h3>
                        <div class="pt-5">
                          <p v-html="individualcourse.glossary"></p>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
  
                  <v-divider></v-divider>
  
                  <v-row>
                    <v-col cols="12" md="12">
                      <div class="pt-4 pb-4">
                        <h3>{{ 'Description'| translate }}</h3>
                        <div class="pt-5">
                          <p v-html="individualcourse.long_description"></p>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
  
                  <v-divider></v-divider>
  
                  <v-row>
                    <v-col cols="12" md="12" class="pt-4 pb-4">
                      <v-row v-for="authorsdata in individualcourse.authors"
                        :key="authorsdata.author_id">
                        <v-col cols="12" md="3">
                          <v-layout column align-center>
                            <v-flex class="mt-5">
                              <v-avatar size="100">
                                <v-img
                                  class="elevation-6"
                                  :src="storage_url+ authorsdata.author_pic"
                                ></v-img>
                              </v-avatar>
                            </v-flex>
                          </v-layout>
                        </v-col>
                        <v-col cols="12" md="9">
                          <h3>{{ authorsdata.author_name }}</h3>
                          <div class="pt-5">
                            <p>{{ authorsdata.author_info }}</p>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-container>
     
     <template>
      <v-dialog v-model="lockMessage" persistent max-width="560">
        <v-card>
          <v-card-title  v-if="is_subscribed" class="headline">{{ "You need to complete previous modules"| translate }}</v-card-title>
          <v-card-title  v-else class="headline">{{ "You have not subscribed to this course."| translate }}</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" text @click="lockMessage = false">{{ 'Close'| translate }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </template>

  <v-dialog v-if="!loadingdata" v-model="dialog" persistent max-width="1000">
      <v-card >
        <v-card-title class="headline">{{ 'Order Purchase Confirmation' | translate }}</v-card-title>
            <v-card-text>
                <div class="my-4 text-subtitle-1">
                    {{this.course_name}} 
                </div>
                <v-chip-group >
                  <v-chip v-for="(modules, m) in this.course_modules" :key="m">{{modules}}</v-chip>
                </v-chip-group>
            </v-card-text>
            <v-card elevation="0">
              <v-row align="center" justify="space-around">
                <v-col cols="12" sm="7" lg="5">
                    <v-card-title v-if="card_present"> {{'Pay securely using' | translate}} </v-card-title>
                    <v-card-title v-if="!card_present" :class=" no_card_notification ? 'no_card_notification': ''"> {{'Add a Card' | translate}} </v-card-title>
                      <v-row>
                        <v-col v-for="(v, k) in stripeallcards" :key="k" cols="12" sm="6">
                          <v-card v-if="v.is_default" class="mx-auto" max-width="344">
                            <v-card-text>
                              <div>xxxxxxxxxxxx{{v.card_last_four}}</div>

                              <p class="display-1 text--primary">{{v.card_brand}}</p>
                              <div class="text--primary">{{ (Object.keys(currentUser).length !=0 ?  currentUser.name : '') }}</div>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col v-if="card_present" cols="12" sm="12">
                          <div > {{ 'Need to change payment method?' | translate }} <v-btn color="primary darken-1" text @click="gotoProfile()">{{ 'Go to profile' | translate }}</v-btn></div>
                        </v-col>
                        <v-col v-if="!card_present" cols="12" sm="12">
                          <div :class=" no_card_notification ? 'no_card_notification': ''"> {{ 'You dont seem to have a card added to your profile' | translate }} 
                          <v-btn color="primary darken-1" text @click="gotoProfile()">{{ 'Go to profile' | translate }}</v-btn>
                          </div>
                        </v-col>
                      </v-row>
                  
                </v-col>
                <v-col cols="12" sm="5">
                  <v-card max-width="800">
                    <v-card-title class="pb-0">{{'Order Summary' | translate}}</v-card-title>
                    <v-container>
                      <v-row justify="space-between">
                        <v-card-subtitle class="title py-1 pl-3">{{ 'Course' | translate }}</v-card-subtitle>
                        <v-card-subtitle class="title py-1 pr-3">{{'Subtotal' | translate}}</v-card-subtitle>
                      </v-row>
                      <v-row justify="space-between">
                        <v-card-subtitle> {{this.course_name}} </v-card-subtitle>
                        <v-card-subtitle>{{ this.product_amount }}{{this.currency}}</v-card-subtitle>
                      </v-row>
                      
                      <v-divider></v-divider>

                      <v-row justify="space-between">
                        <v-card-subtitle>
                          <v-text-field
                            :label="'Coupon Code' | translate"
                            v-model="coupon_id"
                            outlined
                            dense
                            hide-details
                          ></v-text-field>
                          <div v-if="coupon_valid!=null && !coupon_valid" class="error--text"><v-icon class="theme--dark error--text" small>mdi-alert</v-icon><strong> {{coupon_message|translate}} </strong></div>
                          <div v-if="coupon_valid" class="success--text"><v-icon class="theme--dark success--text" small>mdi-checkbox-marked-circle</v-icon><strong>{{coupon_message|translate}}</strong></div>
                        </v-card-subtitle>
                        <v-card-subtitle>
                          <v-btn
                            rounded
                            small
                            @click="applyCoupon()"
                          >{{'Apply'| translate}}</v-btn>
                          <v-btn
                            rounded
                            small
                            @click="clearCoupon()"
                          >{{'Clear'| translate}}</v-btn>
                        </v-card-subtitle>
                      </v-row>
                      
                      <v-divider></v-divider>

                      <v-row justify="space-between">
                        <v-card-subtitle class="title py-1 pr-3">{{'Total' | translate}}</v-card-subtitle>
                        <v-card-subtitle class="title py-1 pr-3">{{this.product_amount}}{{this.currency}}</v-card-subtitle>
                      </v-row>

                      <v-row justify="center">
                         <v-checkbox v-model="agree_terms" light>
                          <template slot="label">
                            {{'I agree' | translate}} <a @click.stop href="/pages/terms" target="_blank">{{'terms'| translate}}</a>
                          </template>
                        </v-checkbox>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="primary darken-1" text @click="dialog = false">{{ 'Cancel' | translate }}</v-btn>
                          <v-btn color="green darken-1" text @click="subscribe(course_id)" v-if="agree_terms && (coupon_valid || (coupon_valid==null))">{{ 'Subscribe' | translate }}</v-btn>
                        </v-card-actions>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
      </v-card>
    </v-dialog>

    <v-dialog v-model="course_success_dialog" persistent max-width="560">
      <v-card>
        <v-card-title class="headline">{{ "Thank you for Subscribing"| translate }}</v-card-title>
        <v-card-subtitle>{{ "You can find subscribed courses in your Dashboard"| translate }}</v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text to="/dashboard">{{ 'Go to dashboard' | translate }}</v-btn>
          <v-btn color="primary darken-1" text @click="course_success_dialog = false">{{ 'Close'| translate }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

   <v-overlay :value="isLoading">
      <v-layout row justify-center v-if="isLoading">
        <v-dialog v-model="loadingdata" persistent fullscreen content-class="loading-dialog">
          <v-container fill-height>
            <v-layout row justify-center align-center>
              <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>
      </v-layout>
    </v-overlay>
  
    </v-content>
  </template>
  
  <style lang="scss" scoped>
  @media screen and (min-width: 1161px) {
    .floatingbox {
      position: fixed;
      top: 227px;
      right: 70px;
      max-width: 350px;
    }
  }
  
  @media screen and (min-width: 1110px) and (max-width: 1160px) {
    .floatingbox {
      position: fixed;
      top: 227px;
      max-width: 320px;
      right: 60px;
    }
  }
  
  @media screen and (min-width: 1070px) and (max-width: 1109px) {
    .floatingbox {
      position: fixed;
      top: 227px;
      max-width: 290px;
      right: 50px;
    }
  }
  
  @media screen and (min-width: 961px) and (max-width: 1069px) {
    .floatingbox {
      position: fixed;
      top: 227px;
      max-width: 270px;
      right: 42px;
    }
  }
  
  @media screen and (max-width: 961px) {
    .floatingbox {
      position: sticky;
      top: 0;
    }
  
    .learn {
      margin-top: 90px;
    }
  
    .buyimage {
      display: none;
    }
  }
  
  .learn {
    background-color: #f9f9f9;
    border: 1px solid #dedfe0;
    padding: 10px 15px;
  }
  </style>
  
  <script>
  import { mapGetters } from "vuex";
  import { mapState } from "vuex";
  import store from "@/store";
  import {
    FETCH_INDIVIDUAL_COURSE,
    COURSE_SUBSCRIBE,
    RESET_STATE
  } from "@/store/actions.type";
  import { SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type";
  export default {
    name: "CourseDetails",
    async beforeRouteEnter(to, from, next) {
      await store.dispatch(RESET_STATE);
      await store.dispatch(FETCH_INDIVIDUAL_COURSE, to.params.id).then(resp => {
        if (resp.success) {
          store.commit(SET_LOADING, false);
          store.commit(SET_ROUTER_ENTER, false)
  
        }
      });
  
      return next();
    },
    components: {
      // ModuleNotAccessible: () => import("@/components/modal/ModuleNotAccessible"),
    }, 
    computed: {
      ...mapGetters([
        "individualcourse",
        "stripesecretkey",
        "currentUser",
        "loadingdata",
        "languages",
        "stripeallcards"
      ]),
      ...mapState({
        errors: (state) => state.courses.courseerrors,
      }),
    },
    mounted() {
      this.storage_url  = process.env.VUE_APP_STORAGE_URL
      this.module_id = this.individualcourse.module_id;
      this.is_subscribed = this.individualcourse.is_subscribed
      this.price = this.individualcourse.plan
      this.module_slug = this.individualcourse.slug;
      // this.individualcourse.courses.forEach(data => {
      //   if(data.course_status === "draft") {
      //     this.draftStatus = true
      //     return;
      //   }
      // });
      let product_amount = ((this.individualcourse.plan.product_amount)?(this.individualcourse.plan.product_amount):'0')
      let coupon_amount = ((this.individualcourse.plan.coupon_amount !== null)?(this.individualcourse.plan.coupon_amount):null)
      this.courseData.push({'course_id':this.individualcourse.course_id,'product_amount':product_amount, 'coupon_amount': coupon_amount})
  
    },

    data: function() {
      return {
        module_id: null,
        module_slug: null,
        is_subscribed: null,
        dialog: false,
        price: null,
        storage_url: '',
        profileLink: false,
        draftStatus: false,
        lockMessage:false,

        isLoading: false,
        courseData:[],
        course_id: null,
        course_name: null,
        course_modules: [],
        product_amount: null,
        default_product_amount: null,
        currency:null,
        coupon_id: null,
        card_present:false,
        coupon_amount: null,
        coupon_message:null,
        coupon_valid: null,
        course_success_dialog: false,
        no_card_notification:false,
        all_valid: false,
        agree_terms: false,
        
      };
    },
    methods: {
      modulePlayer(course_id,id) {
        localStorage.setItem("lastCourseVisitedId", course_id);
        this.$router.push("/course/"+course_id+"/moduleplayer/" + id);
      },
      checkCard(data) {
        if (this.currentUser.company.account_type == "on-demand") {
        this.coupon_id = null //Clear any previous coupon codes
        this.coupon_valid = null
            this.dialog = true;
            this.course_id = data.course_id
            this.course_name = data.course_name
            this.course_modules.length = 0
            data.company_modules.forEach(element => {
              this.course_modules.push(element.title)
              this.course_modules.push(element.language.lang_name)
            });

            let index = this.courseData.map(function(x) {return x.course_id; }).indexOf(data.course_id)
            this.default_product_amount= this.courseData[index]['product_amount']
            this.product_amount= this.courseData[index]['product_amount']
            this.coupon_amount= this.courseData[index]['coupon_amount']
        if (this.stripeallcards.length !== 0) {
          this.card_present = true;
        }
          
        } else if (this.currentUser.company.account_type == "full-version") {
          this.isLoading = true
          let params={
            id:data.course_id,
          }
          this.$store.dispatch(COURSE_SUBSCRIBE, params).then(resp => {
            if (resp !=undefined && resp.success) {
                this.$store.dispatch(FETCH_INDIVIDUAL_COURSE, data.course_id).then(resp => {
                  if (resp.success) {
                    store.commit(SET_LOADING, false);
                    this.isLoading = false
                    this.filteredcourses = resp.data;
                  }
                }); 
            }
            else{
              store.commit(SET_LOADING, false);
              this.isLoading = false
            }
          });
        }
      },
      canViewModule(courses){
        var canView;
        courses.forEach(element => {
          if(element.show_module == true){
            canView =  true;
          }
        });
        canView==true?true:false;
        return canView;
      },
      getDate(dateString){
          const options = { year: "numeric", month: "long", day: "numeric" }

          let datetoconvert = dateString.replace(/-/g, '/').replace('T', ' ');
          let displayDate = new Date(datetoconvert);

          return new Date(displayDate).toLocaleDateString(this.currentUser.lang_code, options)
      }
    }
  };
  </script>